
























import { Component, Vue } from "vue-property-decorator";
import { LP_PLAN_LINK, SWAP_GROUP_URL } from "hfox/constants";

@Component
class LPPlanTip extends Vue {
  handleToInfo() {
    window.location.href = LP_PLAN_LINK;
  }

  handleToGroup() {
    window.location.href = SWAP_GROUP_URL;
  }
}
export default LPPlanTip;
